<se-fe-card>
  <se-fe-card-header
    seFeDataTitle="Feature: Child Contact Info"
    seFeDataSubtitle="Adding Contact Info for a Child"
  ></se-fe-card-header>

  <se-fe-alert
    seFeDataType="critical">
    Deprecated - this component has been removed from the household setup flow.
  </se-fe-alert>

  <se-fe-card-content>
    <se-po-household-setup-feature-child-contact-info></se-po-household-setup-feature-child-contact-info>
  </se-fe-card-content>
</se-fe-card>
